<template>
  <div v-if="contract_manager">
    <h1 class="main-header">
      <translate translate-context="contract_managers"
                 :translate-params="{id: contract_manager.id, name: contract_manager.name}">
        Create Role - Contract Manager #%{id} - %{name}
      </translate>
    </h1>

    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton color="primary" @click="onClickCreate" v-translate translate-context="form">Create</CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <RoleForm ref="roleForm" :data="emptyRole" @save="onSave" :save_text="$pgettext('form','Create')"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import RoleForm from "@/domain/contract_manager/components/RoleForm.vue";

export default {
  name: 'CreateRole',
  components: {RoleForm},
  data() {
    return {
      loading: true,
      emptyRole: {
        name: '',
        permissions: {},
        visible_by: [],
        description: {},
        public_name: {},
        code: '',
      }
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchConfig({type: 'contract_manager_detail', id: this.$route.params.id}),
        this.fetchContractManager(this.$route.params.id)
      ])
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'contract_manager.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('contractManager', [
      'contract_manager',
    ]),
  },
  methods: {
    ...mapActions('contractManager', [
      'fetchContractManager',
      'createRole',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    onClickCreate() {
      this.$refs.roleForm.triggerSave()
    },
    async onSave(data) {
      await this.createRole(data)
      await this.$router.push({
        name: 'contract_manager.roles', 
        params: {id: this.contract_manager.id}
      })
      throw new SuccessNotification(this.$pgettext('contract_manager', 'Role created!'))
    }
  }
}
</script>